import { geminiLanguageNames } from './geminiLanguages.js';

function buildAliasEntry(hebrewName, englishName, defaultName, extraEntries) {
  const entry = {
    Hebrew: hebrewName,
    English: englishName,
    default: typeof defaultName === 'string' && defaultName.trim() !== '' ? defaultName.trim() : englishName
  };
  if (extraEntries !== undefined && extraEntries !== null && typeof extraEntries === 'object') {
    const keys = Object.keys(extraEntries);
    for (let index = 0; index < keys.length; index += 1) {
      const key = keys[index];
      entry[key] = extraEntries[key];
    }
  }
  return entry;
}

const voiceDisplayAliasesByVoiceId = {
  eve: buildAliasEntry('סיגלית כהן', 'שיר מיטץ', 'Shir Melamed'),
  ara: buildAliasEntry('נועה אברהם', 'Noa Abraham', 'Noa Abraham'),
  leo: buildAliasEntry('איתן כהן', 'Ethan Cohen', 'Ethan Cohen'),
  rex: buildAliasEntry('רון שחר', 'Ryan Stone', 'Ryan Stone'),
  sal: buildAliasEntry('שקד אביטל', 'Sal Rivera', 'Sal Rivera'),
  altair: buildAliasEntry('אלון פרץ', 'Altair Brooks', 'Altair Brooks'),
  atlas: buildAliasEntry('עומר גל', 'Atlas Morgan', 'Atlas Morgan'),
  carina: buildAliasEntry('קרינה לוי', 'Carina Wells', 'Carina Wells'),
  castor: buildAliasEntry('אורן גל', 'Castor Reed', 'Castor Reed'),
  celeste: buildAliasEntry('סלסטה כהן', 'Celeste Hart', 'Celeste Hart'),
  cosmo: buildAliasEntry('עידו גל', 'Cosmo Lane', 'Cosmo Lane'),
  helios: buildAliasEntry('אור שמש', 'Helios Ray', 'Helios Ray'),
  helix: buildAliasEntry('הליקס גל', 'Helix Porter', 'Helix Porter'),
  iris: buildAliasEntry('איריס לוי', 'Iris Bloom', 'Iris Bloom'),
  kepler: buildAliasEntry('גילד כהן', 'Kepler Nash', 'Kepler Nash'),
  lumen: buildAliasEntry('נועה אור', 'Lumen Gray', 'Lumen Gray'),
  luna: buildAliasEntry('נועה רוז', 'Luna Rose', 'Luna Rose'),
  lux: buildAliasEntry('אור כהן', 'Lux Sterling', 'Lux Sterling'),
  naksh: buildAliasEntry('ניר שחר', 'Naksh Patel', 'Naksh Patel'),
  orion: buildAliasEntry('אורן היל', 'Orion Hale', 'Orion Hale'),
  perseus: buildAliasEntry('אבי כהן', 'Perseus Knight', 'Perseus Knight'),
  rigel: buildAliasEntry('רועי צור', 'Rigel Cross', 'Rigel Cross'),
  sirius: buildAliasEntry('סהר גל', 'Sirius Vale', 'Sirius Vale'),
  ursa: buildAliasEntry('Oria Levy', 'Ursa Lane', 'Ursa Lane'),
  zagan: buildAliasEntry('Zohar Cohen', 'Zagan Cole', 'Zagan Cole'),
  zenith: buildAliasEntry('Ron Park', 'Zenith Park', 'Zenith Park'),
  alloy: buildAliasEntry('אלכס כהן', 'Alex Alloy', 'Alex Alloy'),
  ash: buildAliasEntry('Eyal Carter', 'Ash Carter', 'Ash Carter'),
  ballad: buildAliasEntry('Ben Hayes', 'Ballad Hayes', 'Ballad Hayes'),
  coral: buildAliasEntry('Coral Reed', 'Coral Reed', 'Coral Reed'),
  echo: buildAliasEntry('Echo Lane', 'Echo Lane', 'Echo Lane'),
  sage: buildAliasEntry('Shir Morgan', 'Sage Morgan', 'Sage Morgan'),
  shimmer: buildAliasEntry('Shira Rose', 'Shimmer Rose', 'Shimmer Rose'),
  verse: buildAliasEntry('Vered Allen', 'Verse Allen', 'Verse Allen'),
  marin: buildAliasEntry('Marin Cole', 'Marin Cole', 'Marin Cole'),
  cedar: buildAliasEntry('Erez Brooks', 'Cedar Brooks', 'Cedar Brooks')
};

const voiceDisplayAliasesByDisplayName = {
  'shir melamed': buildAliasEntry('שיר מיטץ', 'Shir Melamed', 'Shir Melamed'),
  'yael melamed': buildAliasEntry('Yael Melamed', 'Yael Melamed', 'Yael Melamed'),
  'maya golan': buildAliasEntry('Maya Golan', 'Maya Golan', 'Maya Golan'),
  'nina peretz': buildAliasEntry('Nina Peretz', 'Nina Peretz', 'Nina Peretz'),
  'emma gilad': buildAliasEntry('Emma Gilad', 'Emma Gilad', 'Emma Gilad'),
  'claire carmi': buildAliasEntry('Claire Carmi', 'Claire Carmi', 'Claire Carmi'),
  'grace elhanan': buildAliasEntry('Grace Elhanan', 'Grace Elhanan', 'Grace Elhanan'),
  'mina yadlin': buildAliasEntry('Mina Yadlin', 'Mina Yadlin', 'Mina Yadlin'),
  'huda shatara': buildAliasEntry('Huda Shatara', 'Huda Shatara', 'Huda Shatara'),
  'sarah walker': buildAliasEntry('Sarah Walker', 'Sarah Walker', 'Sarah Walker'),
  'miri rejbi': buildAliasEntry('Miri Rejbi', 'Miri Rejbi', 'Miri Rejbi'),
  'naama lihi': buildAliasEntry('Naama Lihi', 'Naama Lihi', 'Naama Lihi'),
  'shiran adi': buildAliasEntry('Shiran Adi', 'Shiran Adi', 'Shiran Adi'),
  'neta rom': buildAliasEntry('Neta Rom', 'Neta Rom', 'Neta Rom'),
  'lior sela': buildAliasEntry('Lior Sela', 'Lior Sela', 'Lior Sela'),
  'mika paz': buildAliasEntry('Mika Paz', 'Mika Paz', 'Mika Paz'),
  'talia nave': buildAliasEntry('Talia Nave', 'Talia Nave', 'Talia Nave'),
  'ronit eshel': buildAliasEntry('Ronit Eshel', 'Ronit Eshel', 'Ronit Eshel'),
  'yaara tal': buildAliasEntry('Yaara Tal', 'Yaara Tal', 'Yaara Tal'),
  'alma ravid': buildAliasEntry('Alma Ravid', 'Alma Ravid', 'Alma Ravid'),
  'noga peleg': buildAliasEntry('Noga Peleg', 'Noga Peleg', 'Noga Peleg'),
  'noa kerem': buildAliasEntry('Noa Kerem', 'Noa Kerem', 'Noa Kerem'),
  'roni saar': buildAliasEntry('Roni Saar', 'Roni Saar', 'Roni Saar'),
  'hila oren': buildAliasEntry('Hila Oren', 'Hila Oren', 'Hila Oren'),
  'maya shen': buildAliasEntry('Maya Shen', 'Maya Shen', 'Maya Shen'),
  'yael gefen': buildAliasEntry('Yael Gefen', 'Yael Gefen', 'Yael Gefen'),
  'gili hadar': buildAliasEntry('Gili Hadar', 'Gili Hadar', 'Gili Hadar'),
  'rina talor': buildAliasEntry('Rina Talor', 'Rina Talor', 'Rina Talor'),
  'keren amit': buildAliasEntry('Keren Amit', 'Keren Amit', 'Keren Amit'),
  'sivan elad': buildAliasEntry('Sivan Elad', 'Sivan Elad', 'Sivan Elad'),
  'avia kesem': buildAliasEntry('Avia Kesem', 'Avia Kesem', 'Avia Kesem'),
  'daniel shaked': buildAliasEntry('Daniel Shaked', 'Daniel Shaked', 'Daniel Shaked'),
  'noah gal': buildAliasEntry('Noah Gal', 'Noah Gal', 'Noah Gal'),
  'jack ben haim': buildAliasEntry('Jack Ben Haim', 'Jack Ben Haim', 'Jack Ben Haim'),
  'adrian schreiber': buildAliasEntry('Adrian Schreiber', 'Adrian Schreiber', 'Adrian Schreiber'),
  'owen mac': buildAliasEntry('Owen Mac', 'Owen Mac', 'Owen Mac'),
  'kenji malson': buildAliasEntry('Kenji Malson', 'Kenji Malson', 'Kenji Malson'),
  'gal shaked': buildAliasEntry('Gal Shaked', 'Gal Shaked', 'Gal Shaked'),
  'tal david': buildAliasEntry('Tal David', 'Tal David', 'Tal David'),
  'tair lahav': buildAliasEntry('Tair Lahav', 'Tair Lahav', 'Tair Lahav'),
  'adi tal': buildAliasEntry('Adi Tal', 'Adi Tal', 'Adi Tal'),
  'ido cohen': buildAliasEntry('Ido Cohen', 'Ido Cohen', 'Ido Cohen'),
  'maya papaya': buildAliasEntry('Maya Papaya', 'Maya Papaya', 'Maya Papaya'),
  'yarden': buildAliasEntry('Yarden', 'Yarden', 'Yarden'),
  'yerdena': buildAliasEntry('Yerdena', 'Yerdena', 'Yerdena'),
  'eitan': buildAliasEntry('Eitan', 'Eitan', 'Eitan'),
  'daniel regev': buildAliasEntry('Daniel Regev', 'Daniel Regev', 'Daniel Regev'),
  'omer gal': buildAliasEntry('Omer Gal', 'Omer Gal', 'Omer Gal'),
  'eitan dor': buildAliasEntry('Eitan Dor', 'Eitan Dor', 'Eitan Dor'),
  'tom barak': buildAliasEntry('Tom Barak', 'Tom Barak', 'Tom Barak'),
  'adi mor': buildAliasEntry('Adi Mor', 'Adi Mor', 'Adi Mor'),
  'lavi tzur': buildAliasEntry('Lavi Tzur', 'Lavi Tzur', 'Lavi Tzur'),
  'shai romem': buildAliasEntry('Shai Romem', 'Shai Romem', 'Shai Romem'),
  'niv sahar': buildAliasEntry('Niv Sahar', 'Niv Sahar', 'Niv Sahar'),
  'ori lev': buildAliasEntry('Ori Lev', 'Ori Lev', 'Ori Lev'),
  'eyal naveh': buildAliasEntry('Eyal Naveh', 'Eyal Naveh', 'Eyal Naveh'),
  'amit dolev': buildAliasEntry('Amit Dolev', 'Amit Dolev', 'Amit Dolev')
};

const knownFeminineVoiceIds = {
  eve: true,
  ara: true,
  carina: true,
  celeste: true,
  iris: true,
  luna: true,
  ursa: true,
  coral: true,
  shimmer: true,
  marin: true,
  sage: true,
  echo: true
};

const languageAliasKeys = {
  hebrew: 'Hebrew',
  english: 'English',
  arabic: 'Arabic',
  spanish: 'Spanish',
  french: 'French',
  german: 'German',
  italian: 'Italian',
  portuguese: 'Portuguese',
  hindi: 'Hindi',
  japanese: 'Japanese',
  korean: 'Korean',
  chinese: 'Chinese',
  russian: 'Russian'
};

const voiceNameTransliterations = {
  Hebrew: [
    ['tch', 'צ׳'], ['sch', 'ש'], ['sh', 'ש'], ['ch', 'צ׳'], ['kh', 'ח'], ['gh', 'ע׳'], ['ph', 'פ'], ['th', 'ת'], ['dh', 'ד'], ['zh', 'ז׳'], ['ts', 'צ'], ['tz', 'צ'], ['qu', 'קו'], ['ck', 'ק'], ['ee', 'י'], ['ea', 'י'], ['ie', 'י'], ['ai', 'אי'], ['ay', 'אי'], ['ey', 'אי'], ['oy', 'וי'], ['ou', 'ו'], ['oo', 'ו'], ['au', 'או'],
    ['a', 'א'], ['b', 'ב'], ['c', 'ק'], ['d', 'ד'], ['e', 'י'], ['f', 'פ'], ['g', 'ג'], ['h', 'ה'], ['i', 'י'], ['j', 'ג׳'], ['k', 'ק'], ['l', 'ל'], ['m', 'מ'], ['n', 'נ'], ['o', 'ו'], ['p', 'פ'], ['q', 'ק'], ['r', 'ר'], ['s', 'ס'], ['t', 'ט'], ['u', 'ו'], ['v', 'ו'], ['w', 'ו'], ['x', 'קס'], ['y', 'י'], ['z', 'ז']
  ],
  Arabic: [
    ['tch', 'تش'], ['sch', 'ش'], ['sh', 'ش'], ['ch', 'تش'], ['kh', 'خ'], ['gh', 'غ'], ['ph', 'ف'], ['th', 'ث'], ['dh', 'ذ'], ['zh', 'ژ'], ['ts', 'تس'], ['tz', 'تس'], ['qu', 'كو'], ['ck', 'ك'], ['ee', 'ي'], ['ea', 'ي'], ['ie', 'ي'], ['ai', 'اي'], ['ay', 'اي'], ['ey', 'اي'], ['oy', 'وي'], ['ou', 'و'], ['oo', 'و'], ['au', 'او'],
    ['a', 'ا'], ['b', 'ب'], ['c', 'ك'], ['d', 'د'], ['e', 'ي'], ['f', 'ف'], ['g', 'ج'], ['h', 'ه'], ['i', 'ي'], ['j', 'ج'], ['k', 'ك'], ['l', 'ل'], ['m', 'م'], ['n', 'ن'], ['o', 'و'], ['p', 'ب'], ['q', 'ك'], ['r', 'ر'], ['s', 'س'], ['t', 'ت'], ['u', 'و'], ['v', 'ف'], ['w', 'و'], ['x', 'كس'], ['y', 'ي'], ['z', 'ز']
  ]
};

const supportedLanguageNames = Array.isArray(geminiLanguageNames) === true ? geminiLanguageNames : [];

function normalizeLanguageKey(valueParam) {
  const value = typeof valueParam === 'string' ? valueParam.trim().toLowerCase() : '';
  if (value === '') {
    return '';
  }
  if (value === 'he' || value === 'iw' || value === 'hebrew' || value === 'עברית') {
    return 'Hebrew';
  }
  if (value === 'en' || value === 'english') {
    return 'English';
  }
  if (value === 'ar' || value === 'arabic' || value === 'العربية') {
    return 'Arabic';
  }
  if (value === 'es' || value === 'es-ar' || value === 'spanish') {
    return 'Spanish';
  }
  if (value === 'fr' || value === 'french') {
    return 'French';
  }
  if (value === 'de' || value === 'german') {
    return 'German';
  }
  if (value === 'it' || value === 'italian') {
    return 'Italian';
  }
  if (value === 'pt' || value === 'portuguese') {
    return 'Portuguese';
  }
  if (value === 'hi' || value === 'hindi') {
    return 'Hindi';
  }
  if (value === 'ja' || value === 'japanese') {
    return 'Japanese';
  }
  if (value === 'ko' || value === 'korean') {
    return 'Korean';
  }
  if (value === 'zh' || value === 'chinese') {
    return 'Chinese';
  }
  if (value === 'ru' || value === 'russian') {
    return 'Russian';
  }
  const normalized = value.replace(/[^a-z]/g, '');
  if (languageAliasKeys[normalized] !== undefined) {
    return languageAliasKeys[normalized];
  }
  for (let index = 0; index < supportedLanguageNames.length; index += 1) {
    const languageName = supportedLanguageNames[index];
    if (typeof languageName === 'string' && languageName.trim().toLowerCase() === value) {
      return languageName.trim();
    }
  }
  const titleCase = value.charAt(0).toUpperCase() + value.slice(1);
  if (titleCase !== '') {
    return titleCase;
  }
  return '';
}

function resolveVoiceLookupKey(voiceParam) {
  const voice = voiceParam !== null && voiceParam !== undefined && typeof voiceParam === 'object' ? voiceParam : null;
  if (voice === null) {
    return '';
  }
  const voiceId = typeof voice.voiceId === 'string' ? voice.voiceId.trim().toLowerCase() : '';
  if (voiceId !== '') {
    return voiceId;
  }
  const voiceName = typeof voice.voiceName === 'string' ? voice.voiceName.trim().toLowerCase() : '';
  if (voiceName !== '') {
    return voiceName;
  }
  return '';
}

function resolveDisplayNameLookupKey(voiceParam) {
  const voice = voiceParam !== null && voiceParam !== undefined && typeof voiceParam === 'object' ? voiceParam : null;
  if (voice === null) {
    return '';
  }
  const displayName = typeof voice.displayName === 'string' ? voice.displayName.trim().toLowerCase() : '';
  if (displayName !== '') {
    return displayName;
  }
  return '';
}

function resolveAliasEntry(voiceParam) {
  const voice = voiceParam !== null && voiceParam !== undefined && typeof voiceParam === 'object' ? voiceParam : null;
  if (voice === null) {
    return null;
  }
  const lookupKey = resolveVoiceLookupKey(voice);
  if (lookupKey !== '' && voiceDisplayAliasesByVoiceId[lookupKey] !== undefined) {
    return voiceDisplayAliasesByVoiceId[lookupKey];
  }
  const displayNameKey = resolveDisplayNameLookupKey(voice);
  if (displayNameKey !== '' && voiceDisplayAliasesByDisplayName[displayNameKey] !== undefined) {
    return voiceDisplayAliasesByDisplayName[displayNameKey];
  }
  return null;
}

function readAliasValue(aliasEntry, languageKey) {
  if (aliasEntry === null || aliasEntry === undefined || typeof aliasEntry !== 'object') {
    return '';
  }
  if (languageKey !== '' && typeof aliasEntry[languageKey] === 'string' && aliasEntry[languageKey].trim() !== '') {
    return aliasEntry[languageKey].trim();
  }
  return '';
}

function resolveVoiceNameSource(voiceParam) {
  const voice = voiceParam !== null && voiceParam !== undefined && typeof voiceParam === 'object' ? voiceParam : null;
  if (voice === null) {
    return '';
  }
  if (typeof voice.displayName === 'string' && voice.displayName.trim() !== '') {
    return voice.displayName.trim();
  }
  if (typeof voice.voiceName === 'string' && voice.voiceName.trim() !== '') {
    return voice.voiceName.trim();
  }
  if (typeof voice.voiceId === 'string' && voice.voiceId.trim() !== '') {
    return voice.voiceId.trim();
  }
  return '';
}

function transliterateVoiceName(valueParam, languageKeyParam) {
  const value = typeof valueParam === 'string' ? valueParam.trim() : '';
  const languageKey = typeof languageKeyParam === 'string' ? languageKeyParam : '';
  const pairs = Array.isArray(voiceNameTransliterations[languageKey]) === true ? voiceNameTransliterations[languageKey] : [];
  if (value === '' || pairs.length === 0 || /[A-Za-z]/.test(value) === false) {
    return value;
  }
  let output = '';
  let index = 0;
  while (index < value.length) {
    let replacement = '';
    let matchedLength = 0;
    for (let pairIndex = 0; pairIndex < pairs.length; pairIndex += 1) {
      const pair = pairs[pairIndex];
      const source = pair[0];
      if (value.slice(index, index + source.length).toLowerCase() === source) {
        replacement = pair[1];
        matchedLength = source.length;
        break;
      }
    }
    if (matchedLength > 0) {
      output = output + replacement;
      index = index + matchedLength;
    } else {
      output = output + value[index];
      index = index + 1;
    }
  }
  return output;
}

export function isFeminineVoice(voiceParam) {
  const voice = voiceParam !== null && voiceParam !== undefined && typeof voiceParam === 'object' ? voiceParam : null;
  if (voice === null) {
    return false;
  }
  const lookupKey = resolveVoiceLookupKey(voice);
  if (lookupKey !== '' && knownFeminineVoiceIds[lookupKey] === true) {
    return true;
  }
  const gender = typeof voice.gender === 'string' ? voice.gender.trim().toLowerCase() : '';
  if (gender === 'female' || gender === 'feminine') {
    return true;
  }
  const catalogDescription = typeof voice.catalogDescription === 'string' ? voice.catalogDescription.trim().toLowerCase() : '';
  if (catalogDescription.includes('female voice') === true || catalogDescription.includes('feminine voice') === true) {
    return true;
  }
  const description = typeof voice.description === 'string' ? voice.description.trim().toLowerCase() : '';
  if (description.includes('female voice') === true || description.includes('feminine voice') === true) {
    return true;
  }
  return false;
}

export function resolveFeminineVoiceAlias(voiceParam, languageParam, accentParam) {
  return resolveVoiceDisplayAlias(voiceParam, languageParam, accentParam);
}

export function resolveVoiceDisplayAlias(voiceParam, languageParam, accentParam) {
  const aliasEntry = resolveAliasEntry(voiceParam);
  if (aliasEntry === null) {
    return '';
  }
  const languageKey = normalizeLanguageKey(languageParam);
  const languageAlias = readAliasValue(aliasEntry, languageKey);
  if (languageAlias !== '') {
    return languageAlias;
  }
  const accentKey = normalizeLanguageKey(accentParam);
  const accentAlias = readAliasValue(aliasEntry, accentKey);
  if (accentAlias !== '') {
    return accentAlias;
  }
  const englishAlias = readAliasValue(aliasEntry, 'English');
  if (englishAlias !== '') {
    return englishAlias;
  }
  const defaultAlias = readAliasValue(aliasEntry, 'default');
  if (defaultAlias !== '') {
    return defaultAlias;
  }
  return '';
}

export function resolveVoiceDisplayName(voiceParam, languageParam, accentParam) {
  const voice = voiceParam !== null && voiceParam !== undefined && typeof voiceParam === 'object' ? voiceParam : null;
  if (voice === null) {
    return '';
  }
  const languageKey = normalizeLanguageKey(languageParam);
  const aliasEntry = resolveAliasEntry(voice);
  const alias = readAliasValue(aliasEntry, languageKey);
  if (alias !== '') {
    return alias;
  }
  return transliterateVoiceName(resolveVoiceNameSource(voice), languageKey);
}

export function collectFeminineVoiceSearchTerms(voiceParam) {
  return collectVoiceDisplaySearchTerms(voiceParam);
}

export function collectVoiceDisplaySearchTerms(voiceParam) {
  const aliasEntry = resolveAliasEntry(voiceParam);
  if (aliasEntry === null) {
    return [];
  }
  const terms = [];
  const keys = Object.keys(aliasEntry);
  for (let index = 0; index < keys.length; index += 1) {
    const key = keys[index];
    const value = aliasEntry[key];
    if (typeof value === 'string' && value.trim() !== '') {
      terms.push(value.trim());
    }
  }
  return terms;
}
